import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { loginAdmin } = useAuth();
  const [email, setEmail] = useState("admin@teuralink.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await loginAdmin(email, password);
      toast.success("Welcome back, Admin");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pt-32 px-6 relative z-10 min-h-screen">
      <form onSubmit={submit} className="max-w-md mx-auto glass rounded-3xl p-8">
        <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
          <Lock className="w-5 h-5 text-gold" />
        </div>
        <div className="overline text-gold mt-6">Admin Access</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-2">Sign in to Teuralink Console</h1>

        <label className="block mt-8">
          <span className="overline block mb-2">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email"
            className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/40"
          />
        </label>
        <label className="block mt-4">
          <span className="overline block mb-2">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
            className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/40"
          />
        </label>

        <button type="submit" disabled={busy} className="btn-primary mt-6 w-full justify-center" data-testid="admin-submit">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
        </button>
      </form>
    </div>
  );
}
